<template>
    <div class="bg_main">
    <v-container>
        <v-card class="card-orders-list">
                <v-card-title class="pb-0 text-family  text-pantone font-weight-bold">Cambio de contraseña</v-card-title>
                <v-card-subtitle class="grey--tex float-left text-family my-0">Cambiar la contrseña</v-card-subtitle>
                <v-divider class="mt-10"></v-divider>
            <v-card-text>
                <v-form ref="formPasswords" v-model="formValid">
                    <v-container>
                        <v-row class="mb-4">
                         
                            <v-col cols="12" lg="6" offset-lg="3">
                                <label for="" class="label-form text-family">Ingresa tu nueva contraseña</label>
                                <v-text-field
                                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                    :rules="[formValidator.password.required, formValidator.password.min]"
                                    :type="showPassword ? 'text' : 'password'"
                                    placeholder="Escribe la nueva contraseña."
                                    hint="Ingresa una contraseña que puedas recordar con facilidad."
                                    @click:append="showPassword = !showPassword"
                                    outlined required
                                    v-model="passwordRequest.password"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" lg="6" offset-lg="3">
                                <label for="" class="label-form text-family">Confirma tu contraseña</label>
                                <v-text-field
                                    :append-icon="showRepeatPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                    :rules="[formValidator.password.passwordMatch(passwordRequest.confirm_password, passwordRequest.password)]"
                                    :type="showRepeatPassword ? 'text' : 'password'"
                                    placeholder="Escribe la misma contrseña del campo anterior"
                                    @click:append="showRepeatPassword = !showRepeatPassword"
                                    outlined required
                                    v-model="passwordRequest.confirm_password"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" lg="6" offset-lg="3">
                                <label for="" class="label-form text-family">Contraseña actual</label>
                                <v-text-field
                                        :append-icon="showCurrentPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                        :rules="[formValidator.password.required, formValidator.password.min]"
                                        :type="showCurrentPassword ? 'text' : 'password'"
                                        placeholder="Escribe tu contraseña actual."
                                        @click:append="showCurrentPassword = !showCurrentPassword"
                                        outlined required
                                        v-model="passwordRequest.current_password"
                                ></v-text-field>
                                    <!-- <v-divider class="my-2"></v-divider> -->
                            </v-col>


                        </v-row>

                        <v-row>
                            <v-col cols="12" class="text-center">
                                <v-btn :color="pantone" class="mx-2 white--text" link :to="{name: 'home'}" large>
                                    Cancelar
                                </v-btn>
                                <v-btn :color="pantoneBlack"  class="mx-2 white--text" large @click="submitForm()">
                                    Aplicar cambios
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card-text>

        </v-card>
    </v-container>
    </div>
</template>

<script>
    import {mapState, mapActions} from 'vuex';
    import registerFormValidator from "bestgob-core/form/register.form.validator";

export default {
    name: "PasswordUpdate",

    data() {
        return {
            formValid: false,

            showPassword: false,
            showRepeatPassword: false,
            showCurrentPassword: false,
            formValidator: registerFormValidator,

            passwordRequest: {
                password: '',
                confirm_password: '',
                current_password: ''
            },
            pantone: '#B08C55',
            pantoneBlack: '#15212F'

        }
    },

    computed: {
        ...mapState({accountStore: state => state.account})
    },

    methods: {
        ...mapActions('account', ['changeAccountPassword']),

        submitForm(){
            this.$refs.formPasswords.validate()

            if (this.formValid){
                //VueX
                this.changeAccountPassword(this.passwordRequest)
            }
        }

    },
}
</script>

<style >


    .card-orders-list {
        min-height: 85vh;
    }
    .card-orders-list {
        min-height: 85vh;
    }
    /* .v-input__slot{
        align-items: center;
        color: inherit;
        display: flex;
        min-height: inherit;
        padding: .9rem  1rem !important;
        font-size: 1.25rem;
        line-height: 1.5;
        border-radius: 10px;
        display: flex;
        width: 100%;
        color: #ff8400 !important;
        background-color: #fff !important;
        background-clip: padding-box;
        font-family: 'PoppinsRegular' !important;

        border: 1px  solid #ff8400 !important;
        border-radius: 0.25rem;
        transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    }     */

    .montserrat{
        font-family: "Montserrat" !important;
    }

    .v-application.fondo_login fieldset{
        border-bottom: 0px !important
    }
    /* .v-text-field--filled > .v-input__control > .v-input__slot, .v-text-field--full-width > .v-input__control > .v-input__slot, .v-text-field--outlined > .v-input__control > .v-input__slot{
        min-height: unset !important;
    } */

    .v-text-field--full-width .v-input__prepend-outer, .v-text-field--full-width .v-input__prepend-inner, .v-text-field--full-width .v-input__append-inner, .v-text-field--full-width .v-input__append-outer, .v-text-field--enclosed .v-input__prepend-outer, .v-text-field--enclosed .v-input__prepend-inner, .v-text-field--enclosed .v-input__append-inner, .v-text-field--enclosed .v-input__append-outer{
        margin-top: 0 !important;
    }

    .v-text-field--focused{
        transition: unset !important;   
    }
    .text-pantone{
        color: #B08C55;
    }
    .text-family{
        font-family: 'PoppinsRegular' !important;
    }
</style>